import React from 'react';
import '../../App.css';


export default function ArtistHome() {

  return (
    <>
      <h1>Artist HomePage</h1>
    </>
  );
//   TODO Vlad
}